import React from 'react';
import PropTypes from 'prop-types';

import Trix from 'trix';
import { ReactTrixRTEInput, ReactTrixRTEToolbar } from 'react-trix-rte';

// Trix editor: A rich text editor for everyday writing.
// URL: https://trix-editor.org/

const defaultToolbarActions = [
  'bold',
  'italic',
  'strike',
  'heading1',
  'quote',
  'code',
  'bullet',
  'number',
  'undo',
  'redo',
];

const TextEditor = ({ editorId, onChange, defaultValue, placeholder, toolbarActions }) => {
  return (
    <>
      <ReactTrixRTEToolbar
        toolbarActions={toolbarActions ? toolbarActions : defaultToolbarActions}
        toolbarId={editorId}
      />
      <ReactTrixRTEInput
        toolbarId={editorId}
        defaultValue={defaultValue}
        placeholder={placeholder}
        onChange={onChange}
      />
    </>
  );
};

TextEditor.prototypes = {
  editorId: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  toolbarActions: PropTypes.objectOf(PropTypes.string),
};

TextEditor.defaultProps = {
  toolbarActions: null,
};

export { TextEditor };
